// Retourne true si deux périodes s'enchevauchent. Les dates de début sont inclusives alors que les dates de fin sont exclusives.
export function periodsOverlap(debut1, fin1, debut2, fin2) {
  return debut1.getTime() >= debut2.getTime() && debut1.getTime() < fin2.getTime()
      || fin1.getTime() >= debut2.getTime() && fin1.getTime() < fin2.getTime()
      || debut2.getTime() >= debut1.getTime() && debut2.getTime() < fin1.getTime();
}